import { z } from 'zod';
import { createVersionedSchema } from '@mutiny-pkg/versioned-schema/src';
import { BlockConfigSchema as BlockConfigSchemaV1 } from './version1/BlockConfig.types';
import { BlockConfigSchema as BlockConfigSchemaV2 } from './version2/BlockConfig.types';
import { migrateToV2 } from './version2/migrator';

export * from './version2/CTAConfig.types';
export * from './version2/EmbedConfig.types';
export * from './version2/EmbeddedSnippetConfig.types';
export * from './version2/FooterConfig.types';
export * from './version2/HeadConfig.types';
export * from './version2/HeroConfig.types';
export * from './version2/LogoBarConfig.types';
export * from './version2/MagicResourceLibraryConfig.types';
export * from './version2/NavBarConfig.types';
export * from './version2/ResourceLibraryConfig.types';
export * from './version2/TestimonialConfig.types';
export * from './version2/Types';
export * from './version2/ValuePropConfig.types';
export * from './version2/SpotlightConfig.types';
export * from './version2/NaiveBookMeetingConfig.types';
export * from './version2/PagePasswordConfig.types';

export const BlockConfigSchema = createVersionedSchema()
  .defineVersion(BlockConfigSchemaV1)
  .defineVersion(BlockConfigSchemaV2, migrateToV2);

export type BlockConfig = z.infer<typeof BlockConfigSchema.latestVersionSchema>;
